/*
 *
 *  Vuetify
 */

// deps
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import ar from 'vuetify/es5/locale/ar'
import { gray, red, orange, green, teal, blue } from '@/plugins/vuetify/colors'

// use
Vue.use(Vuetify)

// init vuetify
export default new Vuetify({
  theme: {
    dark: true,
    options: {
      customProperties: true
    },
    themes: {
      dark: {
        // palette
        primary: orange,
        secondary: gray,
        // ui colors
        info: blue,
        success: green,
        warning: orange,
        error: red,
        // all colors
        red,
        green,
        teal,
        blue
      }
    }
  },
  lang: {
    locales: { ar },
    current: 'ar'
  },
  rtl: true,
  icons: {
    iconfont: 'mdi'
  }
})
